import api from '@/api'

export default class SettingsApi {
	static async init(data) {
		return api.post('/settings/init', data).then(function (response) {
			return response.data
		})
	}

	static async shield(data) {
		return api.post('/settings/shield', data).then(function (response) {
			return response.data
		})
	}

	static async countriesSave(data) {
		return api.post('/settings/countries-save', data).then(function (response) {
			return response.data
		})
	}

	static async captchaSave(data) {
		return api.post('/settings/captcha-save', data).then(function (response) {
			return response.data
		})
	}

	static async levelSave(data) {
		return api.post('/settings/level-save', data).then(function (response) {
			return response.data
		})
	}

	static async restoreUser(data) {
		return api.post('/settings/restore-user', data).then(function (response) {
			return response.data
		})
	}

	static async deleteUser(data) {
		return api.post('/settings/delete-user', data).then(function (response) {
			return response.data
		})
	}
}
